import React from "react";
import PropTypes from "prop-types";
import MainButton from "../../Elements/MainButton/MainButton";

import successIcon from "../../../assets/icons/flash-message/success.png";
import errorIcon from "../../../assets/icons/flash-message/exclamation.png";

import "./TopUpStatusModal.css";
import { useTranslation } from "react-i18next";

const TopUpStatusModal = ({ isOpen, type = "success", isPayPal = false, onClose, customMessage }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const isSuccess = type === "success";
  const message = isSuccess
    ? isPayPal
      ? t("topUpStatusModal.msgPaypalTopup")
      : t("topUpStatusModal.msgSuccessTopup")
    : customMessage || t("topUpStatusModal.msgCanceledTopup");

  const handleOverlayClick = () => {
    onClose();
  };

  const handlePrimaryClick = () => {
    onClose();
  };

  return (
    <div className="topup-status-modal-overlay" onClick={handleOverlayClick}>
      <div className="topup-status-modal" onClick={(e) => e.stopPropagation()}>
        <div className="topup-status-modal-icon">
          <img src={isSuccess ? successIcon : errorIcon} alt={isSuccess ? t("common.success") : t("common.error")} />
        </div>

        <h2 className={`topup-status-modal-title ${isSuccess ? "success" : "canceled"}`}>
          {isSuccess ? t("topUpStatusModal.titleSuccess") : t("topUpStatusModal.titleCanceled")}
        </h2>

        <p className="topup-status-modal-message">{message}</p>

        <div className="topup-status-modal-actions">
          <MainButton onClick={handlePrimaryClick} className="topup-status-btn">
            {t("topUpStatusModal.btnBackToAccount")}
          </MainButton>
        </div>
      </div>
    </div>
  );
};

TopUpStatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(["success", "canceled"]),
  isPayPal: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  customMessage: PropTypes.string,
};

export default TopUpStatusModal;
